import { useState } from 'react';
import { Box, Drawer, AppBar, Toolbar, Typography, useTheme, useMediaQuery, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { ToastContainer } from "react-toastify";
import qdataLogo from '../images/logo.png';
import { Settings, SupportAgent } from '@mui/icons-material';

const SideNav = () => {
  const [open, setOpen] = useState(false);
  const { logout } = UserAuth();
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const whatsapp_chat = () => {
    const encodedPhoneNumber = encodeURIComponent(2348109682599);
    const messageLines = [
        'Hello Good Day',
        "I'm from QData website"
      ];
      
    const encodedMessage = messageLines.map(line => encodeURIComponent(line)).join('%0A');
    
    const whatsappLink = `https://api.whatsapp.com/send?phone=${encodedPhoneNumber}&text=${encodedMessage}`;
  
    // Open the WhatsApp chat link in a new window or tab
    window.open(whatsappLink, '_blank');
  };

  // const toggleSidebar = () => {
  //   setOpen(!open);
  // };

  // const logoutUser = async () => {
  //   try {
  //     await logout();
  //     navigate('/login');
  //   } catch (error) {
  //     showToast(error.message);
  //   }
  // };

  // const navigateTo = (path) => {
  //   navigate(path);
  // };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#081247", justifyContent: 'center', paddingY: 1}}>
        <Toolbar 
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Box 
                sx={{ 
                    display: "flex", 
                    flexDirection: 'row', 
                    alignItems: 'center'
                }}
            >
                <img 
                    src={qdataLogo} 
                    style={{ 
                        width: isMobile ? '35px' : '35px',
                        height: isMobile ? '35px' : '35px'
                    }}
                />
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        fontSize: isMobile ? '25px' : '30px',
                        color: 'grey.400'
                    }}
                >
                    Data
                </Typography>
            </Box>

            <Box sx={{ flexGrow: 1 }} />

            <IconButton color="inherit" onClick={whatsapp_chat}>
                <SupportAgent sx={{ color: 'white' }} />
            </IconButton>

            <IconButton color="inherit" onClick={() => navigate('/settings')}>
                <Settings sx={{ color: 'white' }} />
            </IconButton>
        </Toolbar>
    </AppBar>
  );
};

export default SideNav;
